(ns frontend.ui.component.rich-text-editor.view
  "This component is the encapsulation of UI component react-draft-wysiwyg [0]
   which itself uses Facebook's Draft.js [1].

   Styling is done in two places:

   - react-draft-wysiwyg's own stylesheet (should be provided by our backend)
     TODO as copied from
     `./node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css`
   - `./style.cljs` declares global styles that override react-draft-wysiwyg's

   [0]: https://github.com/jpuri/react-draft-wysiwyg
   [1]: https://draftjs.org/
   [2]: https://gist.github.com/nrfm/0c33d297e8ae5cf36c98ef640003a118"
  (:require
   ["react-draft-wysiwyg" :refer [Editor]]
    [reagent.core :as r]
    [herb.core :as h]
    [frontend.ui.component.rich-text-editor.style :as style]))

(def all-toolbar-options
  {"options" ["textAlign" "inline" "list" "link" "blockType"]
   "inline"  {"options" ["bold" "italic" "underline" "strikethrough" "monospace"]}
   "link"    {"options"             ["link"]
              "defaultTargetOption" "_blank"
              "popupClassName" (h/<class style/link-popup)}})

(def no-align-toolbar-options
  {"options"   ["inline" "list" "link" "blockType"]
   "blockType" {"options" [
                           "Normal"
                           "H1"
                           "H2"]}
   "inline"    {"options" ["bold" "italic" "underline" "strikethrough" "monospace"]}
   "link"    {"options"             ["link"]
              "defaultTargetOption" "_blank"
              "popupClassName" (h/<class style/link-popup)}})

(defn rich-text-editor
  [{:keys [read-only? toolbar border? editor-in-modal?] :as props} editor-state]
  (r/create-class
   {:display-name   "rich-text-editor"
    :reagent-render
    (fn [{:keys [read-only?]} editor-state]
      [:> Editor
       (merge {:editorState         @editor-state
               :onEditorStateChange #(reset! editor-state %)
               :spellCheck          true
               :readOnly            (boolean read-only?)
               :toolbar             all-toolbar-options
               :toolbarHidden       (boolean read-only?)
               :placeholder         (if read-only?
                                      ""
                                      "Write your text here …")
               :editorStyle         (merge (when-not border?
                                             {"border"     "none"
                                              "background" "none"})
                                           (when editor-in-modal?
                                             {"maxHeight" "50vh"
                                              "overflowY" "auto"}))}
              (select-keys props [:toolbar]))])}))
